import checkRut from "./checkRut";
import checkPhone from "./checkPhone";

export const switchValidation = (type) => {
    switch (type) {
        case "rut":
            return checkRut;
        case "phone":
            return checkPhone;
    }
};

export default switchValidation;
